import DraggableTable from '../utils/DraggableTable';

export default class BackofficeMenusIndex extends DraggableTable {
  constructor() {
    super('draggable-tbody');
    this.bindEvents();
    this.bindChildrenDragEvents();
  }

  bindEvents() {
    $(".menu-item-toggle").off('change', this.toggleMenuItem).on('change', this.toggleMenuItem);
    $(".add-to-config-btn").off('click').on('click', (e) => this.addToConfig(e));
  }

  bindChildrenDragEvents() {
    // Initialize drag and drop for children tables
    const childrenTbodies = document.querySelectorAll('.children-sortable');
    childrenTbodies.forEach(tbody => {
      this.initChildDraggable(tbody);
    });
  }

  initChildDraggable(tbody) {
    let draggedRow = null;

    tbody.addEventListener('dragstart', (e) => {
      draggedRow = e.target.closest('tr');
      if (draggedRow) {
        draggedRow.style.opacity = 0.5;
      }
    });

    tbody.addEventListener('dragend', (e) => {
      const row = e.target.closest('tr');
      if (row) {
        row.style.opacity = '';
      }
      draggedRow = null;
    });

    tbody.addEventListener('dragover', (e) => {
      e.preventDefault();
      const target = e.target.closest('tr');
      if (target && target !== draggedRow) {
        const { y, height } = target.getBoundingClientRect();
        const offset = y + height / 2;
        if (e.clientY - offset > 0) {
          target.style.borderBottom = '2px solid #000';
          target.style.borderTop = '';
        } else {
          target.style.borderTop = '2px solid #000';
          target.style.borderBottom = '';
        }
      }
    });

    tbody.addEventListener('dragleave', (e) => {
      const target = e.target.closest('tr');
      if (target) {
        target.style.borderBottom = '';
        target.style.borderTop = '';
      }
    });

    tbody.addEventListener('drop', (e) => {
      e.preventDefault();
      const target = e.target.closest('tr');
      if (target && target !== draggedRow && draggedRow) {
        const { y, height } = target.getBoundingClientRect();
        const offset = y + height / 2;
        if (e.clientY - offset > 0) {
          target.after(draggedRow);
        } else {
          target.before(draggedRow);
        }
        target.style.borderBottom = '';
        target.style.borderTop = '';
        this.updateChildrenOrder(tbody);
      }
    });
  }

  updateOrder() {
    const rows = document.querySelectorAll(`#${this.tableId} tr.parent-row`);
    const ids = Array.from(rows).map(row => row.dataset.id);
    const url = $("#draggable-tbody").data('url');

    $.ajax({
      url: url,
      method: 'PUT',
      data: { menu_item_ids: ids },
      success: function() {
        application.successNotification(I18n.t("backoffice.menus.update.success"));
      },
      error: function() {
        application.errorNotification(I18n.t("backoffice.menus.update.error"));
      }
    });
  }

  updateChildrenOrder(tbody) {
    const rows = tbody.querySelectorAll('tr');
    const ids = Array.from(rows).map(row => row.dataset.id);
    const url = tbody.dataset.url;

    $.ajax({
      url: url,
      method: 'PUT',
      data: { children_ids: ids },
      success: function() {
        application.successNotification(I18n.t("backoffice.menus.update.success"));
      },
      error: function() {
        application.errorNotification(I18n.t("backoffice.menus.update.error"));
      }
    });
  }

  toggleMenuItem(e) {
    const checkbox = e.target;
    const url = checkbox.dataset.url;
    const checked = checkbox.checked;
    
    $.ajax({
      url: url,
      method: 'PUT',
      data: { active: checked },
      success: function() {
        application.successNotification(I18n.t("backoffice.menus.update.success"));
      },
      error: function() {
        application.errorNotification(I18n.t("backoffice.menus.update.error"));
      }
    });
  }

  addToConfig(e) {
    e.preventDefault();
    const button = $(e.currentTarget);
    const url = button.data('url');
    const identifier = button.data('identifier');
    
    button.prop('disabled', true);
    button.find('i').removeClass('fa-file-export').addClass('fa-spinner fa-spin');
    
    $.ajax({
      url: url,
      method: 'PUT',
      dataType: 'json',
      success: (response) => {
        if (response.already_exists) {
          application.infoNotification(I18n.t("backoffice.menus.already_in_config"));
        } else {
          application.successNotification(I18n.t("backoffice.menus.added_to_config"));
        }
        // Update button to show it's in config
        button.removeClass('btn-outline-success').addClass('btn-success');
        button.find('i').removeClass('fa-spinner fa-spin').addClass('fa-check');
        button.prop('disabled', true);
        button.attr('title', I18n.t("backoffice.menus.in_config"));
      },
      error: () => {
        application.errorNotification(I18n.t("backoffice.menus.add_to_config_error"));
        button.prop('disabled', false);
        button.find('i').removeClass('fa-spinner fa-spin').addClass('fa-file-export');
      }
    });
  }

  onDataChanged(data) {
  }

  onDestroy() {
  }
}
